export interface ICachedNote {
    id?: string;
    title: string;
    text: string;
    date: Date;
    client?: string;
    tags?: string[];
    createdAt?: string;
    updatedAt?: string;
}

let cache: ICachedNote[] | null = null;

export const getNotesCache = (): ICachedNote[] | null => cache;

export const setNotesCache = (notes: ICachedNote[]): void => {
    cache = [...notes];
};

export const updateNoteInCache = (note: ICachedNote): void => {
    if (!cache) return;
    cache = cache.map(n => n.id === note.id ? { ...note } : n);
};

export const addNoteToCache = (note: ICachedNote): void => {
    if (!cache) return;
    cache = [note, ...cache];
};

export const removeNoteFromCache = (noteId: string): void => {
    if (!cache) return;
    cache = cache.filter(n => n.id !== noteId);
};

export const clearNotesCache = (): void => {
    cache = null;
};
